import { Component, OnInit, Input } from '@angular/core';
import { NavigationService } from 'src/app/services/navigation.service';
import { MainModuleType } from '../../../models/application-models/main-module-type';
import { Navbar } from 'src/app/models/application-models/navbar';
import { StagingService } from 'src/app/services/staging.service';
import { OrganisationService } from 'src/app/services/organisation.service';

@Component({
  selector: 'app-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.css']
})
export class MainNavComponent implements OnInit {

  @Input() selectedCentre: MainModuleType;

  @Input() allowPluRanges: boolean;

  centreIndex: number;

  navbarList: Navbar[];

  constructor(
    public organisationService: OrganisationService,
    public navigationService: NavigationService,
    private stagingService: StagingService
  ) { }

  ngOnInit() {
    this.centreIndex = this.navigationService.findCentreIndex(this.selectedCentre);

    switch(this.selectedCentre) {
      case MainModuleType.CONTROLCENTRE:
        this.navigationService.toggleControlCentreCategoryPluRanges(this.allowPluRanges, this.centreIndex);
        break;
      case MainModuleType.STAGINGCENTREMENUPLANNER:
        this.navigationService.toggleMenuPlannerCategoryPluRanges(this.allowPluRanges, this.centreIndex);
        break;
    }

    if (this.organisationService.organisation && !this.organisationService.organisation.isStagingCentreEnabled) {
      this.navigationService.disableStagingCentreNavigator();
    }

    this.navbarList = this.navigationService.navbarList;
  }

  openNavbar(navbar: Navbar){
    this.navigationService.selectedNavbar = navbar;
  }

  getRouterLink(routerLink: string): string {
    if (routerLink.includes(':stagingAreaID') && this.stagingService.activeStagingArea) {
      return routerLink.replace(':stagingAreaID', this.stagingService.activeStagingArea.id);
    }
    return routerLink;
  }
}
